// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__Ik2r3","Success":"Button_Success__naFtk","Danger":"Button_Danger__h0V7H"};